import { map, omit, concat } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_TEMPLATES} from 'vx/mutations'



// Contact state.
const state = {
  templates: []
}

// User state getters.
const getters = {
  /**
   * User state as a decorated object.
   */
  templates: state => state.templates,

  getById: (state) => (id) => {
    return state.templates.find(template => template.id === id)
  }
}

// User actions.
const actions = {

  /**
   * Get a list of clients.
   */
  getTemplates ({ commit }, id, payload) {
    return http.get(`/opportunities/templates/list`).then(response => {
      commit(SET_TEMPLATES, response.data)

      return response
    })
  },
}

// User state mutations.
const mutations = {
  
  /**
  * Set the clients state.
  */
  [SET_TEMPLATES] (state, templates) {
    state.templates = templates
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
